<template>
  <div id="app">
    <!-- DESKTOP HEADER -->
    <div style="height:100%" v-if=loaded>
      <header class="header">
        <div class="container">
          <router-link to="/" class="header-logo">
            <img :src="logo">
          </router-link>
          <!-- <div class="header-city">
            Доставка суши
            <br>
            в Чите
          </div> -->
          <div class="header-phone-time">
            <div class="header-phone">
              <a href="tel:+79141210808">8 914 121 0808</a>
            </div>
            <div class="header-time">
              c 12:00 до 22:00
            </div>
          </div>
          <div class="header-callback">
            <div class="header-callback-button" v-on:click=onCallbackClick>
              Перезвоните мне
            </div>
          </div>
          <div class="header-push"></div>
          <div class="header-links">
            <router-link to="/delivery">Доставка</router-link>
            <router-link to="/about">О нас</router-link>
            <router-link to="/about#contacts">Контакты</router-link>
          </div>
          <div class="header-social">
            <div class="header-social-vk">
              <a href="https://vk.com/idakodelivery" target="_blank" rel="noopener"><img :src="vk"></a>
            </div>
            <div class="header-social-ig">
              <a href="https://instagram.com/idako_delivery_chita" target="_blank" rel="noopener"><img :src="ig"></a>
            </div>
          </div>
        </div>
      </header>

      <!-- MOBILE HEADER -->

      <header class="mobile-header">
        <div class="container">
          <div class="mobile-header-menu" v-on:click=onSidenavOpenClick>
            <img :src="burger">
          </div>
          <router-link to="/" class="mobile-header-logo">
            <img :src="logo">
          </router-link>
          <div class="mobile-header-push"></div>
          <div class="mobile-header-phone">
            <a href="tel:+79141210808">8 914 121 0808</a>
          </div>
          <div class="mobile-header-phone-small">
            <a href="tel:+79141210808">89141210808</a>
          </div>
          <div class="mobile-header-time">
            c 12:00 до 22:00
          </div>
          <div class="mobile-header-cart" v-on:click=onSidecartOpenClick>
            <div class="mobile-header-cart-count" v-if=cartCount>{{cartCount}}</div>
            <img :src="cart">
          </div>
        </div>
      </header>

      <!-- DESKTOP MENU -->

      <nav class="nav">
        <div class="container">
          <div class="nav-item" v-for="(album) in albums" :key="album.id">
            <router-link :to="'/#' + album.titleEn">
              {{album.title}}
            </router-link>
          </div>
          <div class="nav-cart">
            <div class="nav-cart-button noselect" v-on:click=onSidecartOpenClick>Корзина <span class="nav-cart-button-count" v-if=cartCount>{{cartCount}}</span></div>
          </div>
        </div>
      </nav>

      <router-view/>

      <!-- MOBILE MENU -->

      <div class="mobile-sidenav" v-bind:class="{ activemenu: menu }">
        <div class="mobile-sidenav-close" v-on:click=onSidenavCloseClick>&times;</div>
        <div class="mobile-sidenav-logo">
          <router-link to="/" @click.native=onSidenavCloseClick><img :src="logo"></router-link>
        </div>
        <div class="mobile-sidenav-label">Телефон </div>
        <div class="mobile-sidenav-phone mobile-sidenav-margin">
          <a href="tel:+79141210808" >8 914 121 0808</a>
          <div class="mobile-sidenav-phone-callback" v-on:click=onCallbackClick>Перезвонить</div>
        </div>
        <div class="mobile-sidenav-routes">
          <div class="mobile-sidenav-albums">
            <div class="mobile-sidenav-label">Меню </div>
            <router-link class="mobile-sidenav-margin" :to="'/#' + album.titleEn"  v-for="(album) in albums" :key="album.id" @click.native=onSidenavCloseClick>{{album.title}}</router-link>
          </div>
          <div class="mobile-sidenav-links">
            <div class="mobile-sidenav-label">Справка </div>
            <router-link class="mobile-sidenav-margin" to="/delivery" @click.native=onSidenavCloseClick>Доставка</router-link>
            <router-link class="mobile-sidenav-margin" to="/about" @click.native=onSidenavCloseClick>О нас</router-link>
            <router-link style="margin-bottom: 10px;" class="mobile-sidenav-margin" to="/about#contacts" @click.native=onSidenavCloseClick>Контакты</router-link>
            <div class="mobile-sidenav-label">Социальные сети </div>
            <div class="mobile-sidenav-social mobile-sidenav-margin">
              <div class="mobile-sidenav-social-vk">
                <a href="https://vk.com/idakodelivery" target="_blank" rel="noopener"><img :src="vkBlack"></a>
              </div>
              <div class="mobile-sidenav-social-ig">
                <a href="https://instagram.com/idako_delivery_chita" target="_blank" rel="noopener"><img :src="igBlack"></a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- CART MENU -->
      <div class="overtop" v-bind:class="{ activecart: activeCart }" v-on:click=onSidecartCloseClick></div>
      <div class="sidecart" v-bind:class="{ activecart: activeCart }" >
        <div class="sidecart-top">
          <div class="sidecart-name">
            Сумма заказа:
          </div>
          <div class="sidecart-price">
            {{cartCountPrice}}  ₽
          </div>
        </div>
        <div class="sidecart-goods">
          <div class="good" v-for="(good) in cartAndGoods" :key="good.id">
            <div class="good-top">
              <div class="good-image">
                <img :src="good.thumb_photo" :alt="good.title">
              </div>
              <div class="good-title-description-price">
                <div class="good-top-mobile">
                  <div class="good-title">{{good.title}}</div>
                  <div class="good-description">{{good.description}}</div>
                </div>
                <div class="good-bottom-mobile">
                  <div class="good-price-mobile">{{good.price}} ₽</div>
                  <div class="good-cart-mobile-change noselect" v-bind:class="{ 'good-cart-mobile-change-active': good.cart }" >
                    <div class="good-cart-mobile-minus" v-on:click=onAddToCartClick(good.id,false)>-</div>
                    <div class="good-cart-mobile-count">{{good.cart}}</div>
                    <div class="good-cart-mobile-plus" v-on:click=onAddToCartClick(good.id,true)>+</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="sidecart-bottom">
          <div class="sidecart-close noselect" v-on:click=onSidecartCloseClick>Закрыть</div>
          <router-link class="sidecart-order noselect" to="/order" @click.native=onSidecartCloseClick>Заказать</router-link>
          <!-- <router-link class="sidecart-order noselect" to="/order">Заказать</router-link> -->
        </div>

      </div>
    </div>
    <div class="callback-top" v-bind:class="{ activecallback: callback }" >
      <div class="callback-box">
        <label >Телефон </label>
        <input v-model.trim="phone" type="tel" placeholder="Введите Ваш телефон">
        <div class="callback-bottom">
          <div class="callback-close noselect" v-on:click=onCallbackCloseClick>Закрыть</div>
          <div class="callback-order noselect" v-on:click=onCallbackSendClick>Отправить</div>
        </div>
      </div>
    </div>
    <div v-if=!loaded class="page-load blink">
      <div class="page-load-img"><img :src="logo2"></div>
      <div class="page-load-text">Загрузка ...</div>
    </div>
  </div>
</template>

<script>
import logo from '@/assets/logo.svg'
import logo2 from '@/assets/logo2.svg'
import vk from '@/assets/vk.svg'
import ig from '@/assets/ig.svg'
import vkBlack from '@/assets/vk-black.svg'
import igBlack from '@/assets/ig-black.svg'
import burger from '@/assets/burger.svg'
import cart from '@/assets/cart.svg'
import axios from 'axios'

export default {
  data() {
    return {
      menu: false,
      activeCart: false,
      logo: logo,
      logo2: logo2,
      burger: burger,
      vk: vk,
      ig: ig,
      vkBlack: vkBlack,
      igBlack: igBlack,
      cart: cart,
      callback: false,
      phone: '',
      requestLock: false,
    }
  },
  created: function () {
    this.$store.dispatch('getAll')
  },
  computed: {
    loaded (){
      return this.$store.getters.getLoad
    },
    albums () {
      return this.$store.getters.getAlbums
    },
    cartAndGoods () {
      return this.$store.getters.getCartAndGoods
    },
    cartCount (){
      var count = this.$store.getters.getCartCount
      if (count == 0){ // close cart if no item in cart
        this.activeCart = false
        document.body.classList.remove("overflow-hidden")
      }
      return count
    },
    cartCountPrice (){
      return this.$store.getters.getCartCountPrice
    }
  },
  methods: {
    onSidenavOpenClick(){
      this.menu = true;
      document.body.classList.add("overflow-hidden");
    },
    onSidenavCloseClick(){
      this.menu = false;
      document.body.classList.remove("overflow-hidden");
    },
    onSidecartOpenClick(){
      if(this.cartCount>0){ // prevent open cart if no items in cart
        this.activeCart = true;
        document.body.classList.add("overflow-hidden");
      }
    },
    onSidecartCloseClick(){
      this.activeCart = false;
      document.body.classList.remove("overflow-hidden");
    },
    onSidecartOrderClick(){
      alert(1)
    },
    onAddToCartClick(id,type){
      this.$store.dispatch('addToCart',{id, type})
    },
    onCallbackClick(){
      this.callback = true;
      this.menu = false;
      document.body.classList.add("overflow-hidden");
    },
    onCallbackCloseClick(){
      this.callback = false;
      document.body.classList.remove("overflow-hidden");
    },
    async onCallbackSendClick(){
      if(this.phone){
        if(!this.requestLock){
          this.requestLock = true
          var message = ''
          message = message +`\n`
          message = message +`Звонок \n`
          message = message +`Телефон: ${this.phone}\n`
          message = message +`___________________________________`
          try{
            await axios.post('https://api.idako.ru/callback', {message})  
          }catch{
            alert('Ошибка')
          }
          this.requestLock = false;
          this.phone = ''
          this.callback = false;
          document.body.classList.remove("overflow-hidden");
        }
      }
    }
  },
  watch: {
    '$route' () {
      this.menu = false;
      document.body.classList.remove("overflow-hidden");
      this.activeCart = false;
      document.body.classList.remove("overflow-hidden");
    }
  }
}

</script>

<style lang="scss">

@import url('https://fonts.googleapis.com/css?family=Montserrat');

body {
  font-family: 'Montserrat', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  &.height{
    height: 100%;
  }
  &.overflow-hidden{
    overflow: hidden;
  }
}

#app {
  font-family: 'Montserrat', sans-serif;
  height: 100%;
}

html {
  box-sizing: border-box;
  scroll-behavior: smooth;
  min-height: 100%;
  height: 100%;
  -webkit-appearance: none;
}

*, *::before, *::after {
  box-sizing: inherit;
  padding: 0;
  margin: 0;
}

* { -webkit-tap-highlight-color: rgba(0, 0, 0, 0); }

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
      -moz-user-select: none; /* Firefox */
      -ms-user-select: none; /* Internet Explorer/Edge */
          user-select: none; 
}

a{
  text-decoration: none;
  color:#2c3e50;
}
h1{
  font-size: 24px;
  margin: 0 0 10px 0;
}
h2{
  font-size: 18px;
  margin: 0 0 10px 0;
}
h3{
  font-size: 16px;
  margin: 0 0 8px 0;
}
p{
  font-size: 16px;
  margin-bottom: 10px;
  line-height: 1.5;
}
textarea, input{
  -webkit-appearance: none;
}
textarea:focus, input:focus{
  outline: none;
}

.container{
  width: 1200px;
  margin: 0 auto;
}

.page{
  padding: 20px 15px 20px 10px;
}

@keyframes flickerAnimation {
  0%   { opacity:0.5; }
  50%  { opacity:1; }
  100% { opacity:0.5; }
}


.blink {
  animation: flickerAnimation 2s infinite;
}

.page-load{
  display: flex;
  margin-top: 180px;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  .page-load-img{
    text-align: center;
    margin-bottom: 20px;
    img{
      height: 150px;
    }
  }
  .page-load-text{
    text-align: center;
    font-size: 18px;
    font-weight: bold;
  }
}

.header{
  .container{
    height: 100px;
    padding: 0 10px;
    display: flex;
    .header-logo{
      margin-right: 50px;
      img{
        width: 200px;
      }
      margin-top: 15px;
    }
    .header-city{
      display: flex;
      margin-right: 50px;
      font-size: 20px;
      text-align: center;
      margin-top: 34px;
    }
    .header-phone-time{
      display: flex;
      flex-direction: column;
      margin-right: 50px;
      margin-top: 31px;
      .header-phone{
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 7px;
      }
      .header-time{
        font-size: 14px;
        text-align: center;
        color: #777;
      }
    }
    .header-callback{
      margin-top: 33px;
      .header-callback-button{
        border: 1px solid #aaa;
        color: #777;
        padding: 8px;
        border-radius: 10px;
        font-size: 14px;
        cursor: pointer;
      }
    }
    .header-push{
      flex-grow: 1;
    }
    .header-links{
      align-items: center;
      display: flex;
      margin-right: 16px;
      font-size: 16px;
      a{
        color: #777;
        margin-right: 10px;
        &:hover{
          color: #2c3e50;
        }
      }
    }
    .header-social{
      display: flex;
      margin-top: 32px;
      img{
        border: 1px solid #aaa;
        border-radius: 36px;
        padding: 4px;
        height: 36px;
        widows: 36px;
        &:hover{
          border: 1px solid #888;
        }
      }
      .header-social-vk{
        margin-right: 10px;   
      }
    }
  }
}

.nav{
  z-index: 10;
  font-size: 16px;
  font-weight: bold;
  position: sticky;
  position: -webkit-sticky;
  top: -1px;
  box-shadow:0px 3px 3px #f0f0f0;
  .container{
    height: 56px;
    background-color: white;
    line-height: 56px;
    padding: 0 10px;
  }
  .nav-item{
    float: left;
    margin-right: 20px;
    a{
      &:hover{
        color: #777;
      }      
    }
  }
  .nav-cart{
    float: right;
    padding-top: 9px;
    .nav-cart-button{
      background-color: #D86659;
      color: white;
      padding: 0 15px;
      height: 38px;
      line-height: 38px;
      border-radius: 10px;
      cursor: pointer
    }
    .nav-cart-button-count{
      display: inline-block;
      text-align: center;
      width: 22px;
      height: 22px;
      line-height: 22px;
      background-color: white;
      color: #D86659;
      border-radius: 22px;
      margin-left: 3px;
      font-size: 14px;
    }
  }
}

.mobile-bottom,
.mobile-header,
.popup-album-menu,
.mobile-sidenav{
  display: none;
}

.overtop{
  display: none;
  position: fixed;
  top:0;
  left:0;
  background-color: rgba(0, 0, 0, 0.4);
  width: 100%;
  height: 100%;
  z-index: 11;
  &.activecart{
    display: block;
  }
}

.sidecart {
  display: block;
  height: 100%; /* 100% Full-height */
  width: 0; /* 0 width - change this with JavaScript */
  position: fixed; /* Stay in place */
  z-index: 15; /* Stay on top */
  top: 0; /* Stay at the top */
  right: 0;
  background-color: white;
  overflow-x: hidden; /* Disable horizontal scroll */
  transition: 0.1s; /* 0.5 second transition effect to slide in the mobile-sidenav */
  &.activecart{
    width: 440px;
  }
  .sidecart-goods{
    padding: 10px 0 0 0;
  }
  .sidecart-top,
  .sidecart-bottom{
    // position: sticky;
    // position: -webkit-sticky;
    background-color: white;
    width: 100%;
  }
  .sidecart-top{
    top: 0;
    height: 60px;
    display: flex;
    width:  440px;
    align-items: center;
    justify-content: center;
  }
  .sidecart-name,
  .sidecart-price{
    font-size: 24px;
  }
  .sidecart-price{
    margin-left: 10px;
    min-width: 80px;
  }
  .sidecart-bottom{
    bottom: 0;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 440px;
  }
  .sidecart-close{
    border: 1px solid #777;
    padding: 10px 25px;
    border-radius: 6px;
    font-weight: bold;
    cursor: pointer;
    margin-right: 20px;
  }
  .sidecart-order{
    background-color: #D86659;
    border: 1px solid #D86659;
    color: white;
    padding: 10px 25px;
    border-radius: 6px;
    font-weight: bold;
    cursor: pointer;
  }
  .good{
    width: 100%;
    height: auto;
    margin-bottom: 20px;
    .good-top{
      display: flex;
      flex-direction: row;
      height: 100%;
      .good-image{
        height: auto;
        flex-basis: 30%;
        margin-bottom: 0;
        img{
          width: 100%;
          height: auto; // for tablet
          border-radius: 2px;
        }
      }
      .good-title-description-price{
        padding-left: 10px;
        flex-basis: 70%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .good-title{
          margin-bottom: 4px;
        }
        .good-description{
          font-size: 14px;
          margin-bottom: 4px;
        }
        .good-bottom-mobile{
          display: flex;
          justify-content: space-between;
          height: 36px;
          line-height: 36px;
          bottom: 0;
          .good-price-mobile{
            display: block;
            font-size: 16px;
            font-weight: bold;
          }
          .good-cart-mobile-change{
            display: none;
            width: 100px;
            &.good-cart-mobile-change-active{
              display: flex;
            }
            .good-cart-mobile-minus,
            .good-cart-mobile-plus{
              color: white;
              text-align: center;
              border-radius: 8px;
              background-color: #D86659;
              cursor: pointer;
              font-size: 18px;
              width: 33px;
            }
            .good-cart-mobile-count{
              font-size: 16px;
              width: 33px;
              text-align: center;
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 1300px){
  .container {
    width: 960px;
    margin: 0 auto;
 }
 
  .header{
    .container{

      .header-logo{
        margin-right: 20px;

      }
      .header-city{
        margin-right: 20px;

      }
      .header-phone-time{
        margin-right: 20px;
      }
      .header-links{
        margin-right: 5px;
        a{
          margin-right: 10px;
        }
      }
      .header-social{
        .header-social-vk{
          margin-right: 10px;
        }
      }
    }
  }
}

.callback-top{
  display: none;
  position: fixed;
  top:0;
  left:0;
  background-color: rgba(0, 0, 0, 0.6);
  width: 100%;
  height: 100%;
  z-index: 10;
  justify-content: center;
  align-items: center;
   
  &.activecallback{
    display: flex;
  }
  .callback-box{
    width: 360px;
    padding: 30px;
    background-color: white;
    border-radius: 4px; 
    label{
      color: #777;
      font-size: 20px;
    }
    input{
      margin-top: 15px;
      font-size: 18px;
      width: 100%;
      padding: 10px;
      border: none;
      border:solid 1px #ccc;
      border-radius: 4px;
    }
    .callback-bottom{
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
    }
    .callback-close{
      border: 1px solid #777;
      padding: 10px 25px;
      border-radius: 6px;
      font-weight: bold;
      cursor: pointer;
      margin-right: 20px;
    }
    .callback-order{
      background-color: #D86659;
      border: 1px solid #D86659;
      color: white;
      padding: 10px 25px;
      border-radius: 6px;
      font-weight: bold;
      cursor: pointer;
    }
  }
}

@media only screen and (max-width: 959px){
  .container {
    width: 100%;
    margin: 0 auto;
  }
  .header{
    display: none;
  }
}


@media only screen and (max-width: 959px){
  h1{
    font-size: 22px;
    margin: 0 0 8px 0;
  }
  h2{
    margin: 0 0 8px 0;
  }
  h3{
    margin: 0 0 8px 0;
  }
  p{
    margin-bottom: 8px;
    line-height: 1.4;
  }
  .container {
    width: 100%;
    margin: 0 auto;
  }
  .mobile-header{
    display: block;
    position: sticky;
    position: -webkit-sticky;
    top: 0;
    z-index: 5;
    .container {
      padding: 0 10px;
      height: 60px;
      line-height: 60px;
      background-color:white;
      box-shadow:0px 1px 1px #f0f0f0;
      display: flex;
      justify-content: space-between;
      z-index: 5;
      .mobile-header-menu{
        display: flex;
        margin-top: 22px;
        margin-right: 20px;
        img{
          height: 16px;
          width: 24px;
        } 
      }
      .mobile-header-logo{
        display: flex;
        margin-top: 13px;
        margin-right: 10px;
        img{
          height: 34px;
        }
      }
      .mobile-header-push{
        flex-grow: 1;
      }
      .mobile-header-phone{
        padding-top: 1px;
        text-align: center;
        font-size: 18px;
      }
      .mobile-header-phone-small{
        display: none;
      }
      .mobile-header-time{
        text-align: center;
        font-size: 18px;
        color: #888;
        margin-left: 20px;
      }
      .mobile-header-cart{
        display: flex;
        margin-top: 18px;
        margin-left: 20px;
        img{
          height: 24px;
          width: 24px;
        } 
      }
      .mobile-header-cart-count{
        position: absolute;
        top: 10px;
        right: 2px;
        height: 20px;
        width: 20px;
        border-radius: 20px;
        background-color: #D86659;
        color: white;
        font-size: 12px;
        line-height: 20px;
        text-align: center;
      }
    }
  }
  .nav,
  .header{
    display: none;
  }
  .mobile-sidenav {
    display: block;
    height: 100%; /* 100% Full-height */
    width: 0; /* 0 width - change this with JavaScript */
    position: fixed; /* Stay in place */
    z-index: 5; /* Stay on top */
    top: 0; /* Stay at the top */
    left: 0;
    background-color: white; /* Black*/
    overflow-x: hidden; /* Disable horizontal scroll */
    transition: 0.1s; /* 0.5 second transition effect to slide in the mobile-sidenav */
    &.activemenu{
      width: 100%;
    }
    .mobile-sidenav-close {
      position: absolute;
      top: 5px;
      right: 15px;
      font-size: 45px;
      margin-left: 50px;
      color: #333;
      cursor: pointer;
    }
    .mobile-sidenav-logo{
      margin-bottom: 5px;
      margin-left:10px;
      margin-top: 10px;
      img{
        height: 40px;
      }
    }
    .mobile-sidenav-label{
      font-size: 16px;
      color: #888;
      margin-bottom: 8px;
      margin-left:10px;
    }
    .mobile-sidenav-margin{
      margin-left: 20px;
    }
    .mobile-sidenav-phone{
      font-size: 22px;
      margin-bottom: 8px;
      display: flex;
      align-items: center;
      .mobile-sidenav-phone-callback{
        font-size: 20px;
        color: #888;
        margin-left: 20px;
      }
    }
    
    .mobile-sidenav-routes{
      display: flex;
      flex-direction: row;
      .mobile-sidenav-albums,
      .mobile-sidenav-links{
        margin-left: 0;
        display: flex;
        flex-direction: column;
        a{
          font-size: 22px;
          margin-bottom: 10px;
        }
      }
      .mobile-sidenav-albums{
        margin-bottom: 8px;
        margin-right: 30px;
      }
    }
    .mobile-sidenav-social{
      display: flex;
      margin-bottom: 15px;
      img{
        border: 1px solid #555;
        border-radius: 40px;
        padding: 4px;
        height: 40px;
        width: 40px;
        margin-right: 10px;
      }
    }
  }
  
}

@media only screen and (max-width: 500px){
  .mobile-header{
    .container {
      .mobile-header-time{
        display: none;
      }
    }
  }
  .mobile-sidenav{
    .mobile-sidenav-routes{
      display: flex;
      flex-direction: column;
      .mobile-sidenav-albums{
        margin-right: 0;
      }
    }
  }
  .sidecart {
    &.activecart{
      width: 100%;
    }
    .sidecart-bottom,
    .sidecart-top{
      width: 100%;
    }
  }
  .callback-top{
    .callback-box{
      width: calc(100%-20px);
      border-radius: 2px;
    }
  }
}
@media only screen and (max-width: 340px){
  .mobile-header{
    .container {
      .mobile-header-phone{
        display: none;
      }
      .mobile-header-phone-small{
        display: block;
        text-align: center;
        padding-top: 2px;
        letter-spacing: 1px;
        // font-size: 14px;
      }
      .mobile-header-cart{
        margin-left: 10px;
      }
    }
  }
}

@media only screen and (max-width: 330px){
  .mobile-sidenav{
    .mobile-sidenav-phone{
      .mobile-sidenav-phone-callback{
        font-size: 17px;
        margin-left: 10px;
      }
    }
  }
  .sidecart{
    .good{
      .good-top{
        .good-image{
          flex-basis: 30%;
        }
        .good-title-description-price{
          flex-basis: 70%;
        }
        .good-title-description-price{
          flex-basis: 70%;
          .good-title{
            margin-bottom: 3px;
          }
          .good-description{
            font-size: 12px;
            margin-bottom: 3px;
          }
        }
      }
    }
  }

}


@media only screen and (max-width: 300px){
  .mobile-header{
    .container {
      .mobile-header-phone{
        display: none;
      }
      .mobile-header-phone-small{
        display: none;
      }
    }
  }
}

</style>
